// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__c-HqR","requiredAsterisk":"Info_requiredAsterisk__1bNdK"};